import { Element, Node } from 'slate';
import { v4 as uuidv4 } from 'uuid';
import { ParagraphElement, CustomFormattingElement } from 'slate/types/slate';

export const isParagraph = (node: Node): node is ParagraphElement => Element.isElement(node) && node.type === 'paragraph';
export const isCustomFormatting = (node: Node): node is CustomFormattingElement => Element.isElement(node) && node.type === 'custom-formatting';

export const defaultParagraph = (revisionId?: string): ParagraphElement => ({
  type: 'paragraph',
  uuid: uuidv4(),
  revisionId,
  children: [{ text: '' }],
});
